var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-node-warp"
  }, [_c('h4', [_vm._v("프로토콜 기본정보")]), _c('div', {
    staticClass: "link-item"
  }, [_c('div', {
    staticClass: "one"
  }, [_c('button', {
    staticClass: "MATERIAL",
    class: _vm.nodeLinkData['MATERIAL'].active === false ? 'disabled' : '',
    attrs: {
      "data-items": _vm.nodeLinkData['MATERIAL'].text
    },
    on: {
      "dblclick": function ($event) {
        return _vm.tagPopOn('MATERIAL');
      }
    }
  }, [_c('span', [_vm._v("재료")]), _c('b', [_vm._v(_vm._s(_vm.nodeLinkData['MATERIAL'].text))])])]), _c('div', {
    staticClass: "two b-r"
  }), _c('div', {
    staticClass: "two"
  }), _c('div', {
    staticClass: "three"
  }), _c('div', {
    staticClass: "three b-t b-r b-l"
  }), _c('div', {
    staticClass: "three"
  }), _c('div', {
    staticClass: "two"
  }, [_c('button', {
    staticClass: "MEASUREMENT",
    class: _vm.nodeLinkData['MEASUREMENT'].active === false ? 'disabled' : '',
    attrs: {
      "data-items": _vm.nodeLinkData['MEASUREMENT'].text
    },
    on: {
      "dblclick": function ($event) {
        return _vm.tagPopOn('MEASUREMENT');
      }
    }
  }, [_c('span', [_vm._v("측정")]), _c('b', [_vm._v(_vm._s(_vm.nodeLinkData['MEASUREMENT'].text))])])]), _c('div', {
    staticClass: "two"
  }, [_c('button', {
    staticClass: "ANALYSIS",
    class: _vm.nodeLinkData['ANALYSIS'].active === false ? 'disabled' : '',
    attrs: {
      "data-items": _vm.nodeLinkData['ANALYSIS'].text
    },
    on: {
      "dblclick": function ($event) {
        return _vm.tagPopOn('ANALYSIS');
      }
    }
  }, [_c('span', [_vm._v("분석")]), _c('b', [_vm._v(_vm._s(_vm.nodeLinkData['ANALYSIS'].text))])])]), _c('div', {
    staticClass: "three"
  }), _c('div', {
    staticClass: "three b-b b-r b-l"
  }), _c('div', {
    staticClass: "three"
  }), _c('div', {
    staticClass: "two b-r"
  }), _c('div', {
    staticClass: "two"
  }), _c('div', {
    staticClass: "one"
  }, [_c('button', {
    staticClass: "EQUIPMENT",
    class: _vm.nodeLinkData['EQUIPMENT'].active === false ? 'disabled' : '',
    attrs: {
      "data-items": _vm.nodeLinkData['EQUIPMENT'].text
    },
    on: {
      "dblclick": function ($event) {
        return _vm.tagPopOn('EQUIPMENT');
      }
    }
  }, [_c('span', [_vm._v("장비")]), _c('b', [_vm._v(_vm._s(_vm.nodeLinkData['EQUIPMENT'].text))])])])]), _c('TagOptionPopTagList'), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }